import {
  Arrow,
  Badge,
  ProductCard,
  ProductImage,
  ProductInfo,
  ProductName,
} from '../styles/product.styles'

const ProductCardRelated = ({ item }) => {
  return (
    <ProductCard
      className='product-badge'
      onClick={e => {
        e.stopPropagation()
        window.location.href = `/product/${item.id}/${item.name}`
      }}
    >
      <Badge>Related</Badge>

      <ProductImage src={item.picture} alt={item.name} />

      <ProductInfo>
        <ProductName>{item.name}</ProductName>
        <Arrow>›</Arrow>
      </ProductInfo>
    </ProductCard>
  )
}

export default ProductCardRelated
